/**
 * Fabpad Wear For — pinned path highlight animation.
 */
(function () {
  'use strict';

  var section = document.querySelector('[data-fabpad-wear]');
  if (!section) return;

  var scrollEl = section.querySelector('.fabpad-wear__scroll');
  var swipeHint = section.querySelector('[data-wear-swipe-hint]');

  function updateSwipeHint() {
    if (!scrollEl || !swipeHint) return;

    if (scrollEl.scrollWidth <= scrollEl.clientWidth + 1) {
      swipeHint.classList.add('is-hidden');
      return;
    }

    if (scrollEl.scrollLeft <= 12) {
      swipeHint.classList.remove('is-hidden');
    } else {
      swipeHint.classList.add('is-hidden');
    }
  }

  if (scrollEl && swipeHint) {
    scrollEl.addEventListener('scroll', updateSwipeHint, { passive: true });
    window.addEventListener('resize', updateSwipeHint);
    updateSwipeHint();
  }

  var pins = section.querySelectorAll('[data-wear-pin]');
  var paths = section.querySelectorAll('[data-wear-path]');
  if (!pins.length) return;

  pins = Array.prototype.slice.call(pins).sort(function (a, b) {
    return Number(a.getAttribute('data-wear-pin')) - Number(b.getAttribute('data-wear-pin'));
  });

  var index = 0;
  var timer = null;
  var intervalMs = 1500;
  var prefersReducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  function getPathForPin(pin) {
    var row = pin.closest('[data-wear-row]');
    if (!row) return null;
    return row.querySelector('[data-wear-path]');
  }

  function setActive(i) {
    paths.forEach(function (path) {
      path.classList.remove('is-active');
    });

    pins.forEach(function (pin, n) {
      pin.classList.toggle('is-active', n === i);
    });

    var activePin = pins[i];
    if (!activePin) return;

    var path = getPathForPin(activePin);
    if (path) {
      path.classList.add('is-active');
    }
  }

  function setAllActive() {
    pins.forEach(function (pin) {
      pin.classList.add('is-active');
    });
    paths.forEach(function (path) {
      path.classList.add('is-active');
    });
  }

  function advance() {
    index = (index + 1) % pins.length;
    setActive(index);
  }

  function start() {
    stop();
    if (prefersReducedMotion) {
      setAllActive();
      return;
    }
    setActive(0);
    timer = window.setInterval(advance, intervalMs);
  }

  function stop() {
    if (timer) {
      window.clearInterval(timer);
      timer = null;
    }
  }

  section.addEventListener('mouseenter', stop);
  section.addEventListener('mouseleave', start);

  document.addEventListener('visibilitychange', function () {
    if (document.hidden) {
      stop();
    } else {
      start();
    }
  });

  start();
})();
